<template>
  <div>
    <!-- Tab Navigation -->
    <div
      style="
        margin-left: 2em;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 12px 16px;
        border-bottom: 1px solid #e5e7eb;
        background: linear-gradient(to right, #f9fafb, #f3f4f6);
      "
    >
      <a
        :href="'/diabetes_clinic/diabetes-assessment/' + visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/diabetes_clinic/diabetes-assessment/' + visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🩸 Diabetes Review
      </a>
      <a
        :href="'/diabetes_clinic/diabetes-procedures/' + visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/diabetes_clinic/diabetes-procedures/' + visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🛠️ Procedures
      </a>

      <a
        :href="'/diabetes_clinic/diabetes-history/' + visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/diabetes_clinic/diabetes-history/' + visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        📜 Eye History
      </a>

      <a
        :href="'/diabetes_clinic/diabetes-diagnosis/' + visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/diabetes_clinic/diabetes-diagnosis/' + visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🧠 Diagnosis
      </a>

      <a
        :href="'/diabetes_clinic/diabetes-investigations/' + visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/diabetes_clinic/diabetes-investigations/' + visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        🩻 Investigations
      </a>

      <a
        :href="'/diabetes_clinic/diabetes-imaging/' + visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/diabetes_clinic/diabetes-imaging/' + visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        ☢️ Imaging
      </a>

      <a
        :href="'/diabetes_clinic/diabetes-prescriptions/' + visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/diabetes_clinic/diabetes-prescriptions/' + visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        💊 Prescriptions
      </a>

      <a
        :href="'/diabetes_clinic/diabetes-notes/' + visit_id"
        :class="[
          'tab-link',
          $route.fullPath == '/diabetes_clinic/diabetes-notes/' + visit_id
            ? 'active-tab'
            : '',
        ]"
      >
        📝 Notes
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ancindex",
  props: {
    visit_id: {
      type: [String, Number],
      required: false,
    },
  },
  methods: {
    activeTabChange() {
      this.loading = true;
    },
  },
  mounted() {
    console.log(this.$route.fullPath);
  },
};
</script>

<style scoped>
body {
  font-family: "Inter", sans-serif;
}

/* Base tab link styling */
.tab-link {
  display: inline-block;
  padding: 8px 16px;
  background-color: white;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* Hover effect */
.tab-link:hover {
  background-color: #a9c06d;
  border-color: #9ba854;
  color: #1d4ed8;
  transform: translateY(-1px);
}

/* Active tab */
.active-tab {
  background-color: #1d4ed8;
  color: white !important;
  border-color: #1d4ed8;
  box-shadow: 0 2px 4px rgba(29, 78, 216, 0.25);
  transform: translateY(-1px);
}

/* Optional: subtle transition for layout */
div[style*="flex-wrap"] {
  transition: background 0.3s ease;
}
</style>
